export default "__VITE_ASSET__f5222956__"